@if (data) {
  <h2>{{ 'SIGNUP.COMPANY_DATA' | translate }}</h2>
  <form [formGroup]="form">
    @for (input of inputs; track input) {
      <section>
        <mat-form-field>
          <mat-label>{{ input.displayName | translate }}</mat-label>
          <input
            matInput
            autocomplete="{{ input.autocompleteTag }}"
            formControlName="{{ input.name }}"
            [(ngModel)]="data[input.name.toString()]"
          />
          @if (form.get(input.name).invalid && form.get(input.name).dirty) {
            <mat-error>
              {{ 'SIGNUP.ERROR' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </section>
    }
  </form>
}
